<template>
    <div>
        <van-nav-bar
            :title="extr.title ? extr.title : ''"
            :left-text="extr.leftText ? extr.leftText : ''"
            :right-text="extr.rightText ? extr.rightText : ''"
            :left-arrow="extr.leftArrow ? extr.leftArrow : false"
            :style="`height: ${ $getNavHeight() }px;`"
            @click-left="onClickLeft"
        >
            <template #left>
                <div class="back_div"></div>
            </template>
            <template #title>
                <div class="title_div">
                    {{ extr.title ? extr.title : '' }}
                </div>
            </template>
        </van-nav-bar>
    </div>
</template>

<script>
export default {
    name: 'nav-bar-box',
    data() {
        return {};
    },
    props: {
        extr: {
            type: [Object],
        },
    },
    created() {
    },
    methods: {
        // 返回上一页
        onClickLeft() {
            if (this.extr.leftCallBack) {
                this.extr.leftCallBack();
            } else {
                this.$router.isBack = 1;
                this.$router.go(-1);
            }
        },
        getIsLh() {
            return localStorage.getItem('jy_navbarHeight') ? true : false;
        },
    },

};
</script>

<style lang="stylus" scoped>
.navBar,.navBar_lh
    width: 100vh
    transform: rotate(270deg);
    transform-origin: 0;
    z-index: 999999
    padding-top 26rpx !important
    position: absolute;
    top: calc(100vh - 7vw)
    left: 0
    // >>>.van-nav-bar
    //     padding-top 2vh!important
    //     width: 100vh!important
    //     height: 7vw!important
    //     line-height: 7vw!important
    //     font-size: 0.1rem
    //     overflow hidden
    //     .van-nav-bar__content
    //         height: 7vw!important
    //     .van-nav-bar__title
    //         max-width: 80%
    //         line-height 7vw!important
    //     .back_div
    //         width 40rpx
    //         height 100%
    //         background url(../../assets/images/common/back.png) center no-repeat
    //         background-size 100%
    //     .title_div
    //         font-size: 1.8vw
    //         padding-left: 7vw

// .navBar,.navBar_lh
//     width: 100vh
//     transform: rotate(270deg);
//     transform-origin: 0;
//     z-index: 999999
//     padding-top 40rpx !important
//     position: absolute;
//     top: calc(100vh - 11.3vw)
//     left: 0
//     >>>.van-nav-bar
//         padding-top 0!important
//         width: 100vh!important
//         height: 10vw!important
//         line-height: 10vw!important
//         font-size: 0.1rem
//         .van-nav-bar__content
//             height: 12vw!important
//         .van-nav-bar__title
//             max-width: 80%
//             padding-top: 3vw
//         .back_div
//             width 40rpx
//             height 100%
//             background url(../../assets/images/common/back.png) center no-repeat
//             background-size 100%
//             margin-top: 3vw
//         .title_div
//             font-size: 1.8vw
//             padding-left: 7vw
//             padding-top: 3vw

</style>